import "./styles/global.css"
import './App.css';

import { useEffect , useState } from "react" ; 
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import AboutPage from "./pages/AboutPage";
import BlogPost from "./pages/BlogPost";
function App() {
  return (
    <Router>
  <Navbar />

  <main className="main-content">
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/blog/:id" element={<BlogPost />} />
    </Routes>
  </main>
</Router>

  );
}

export default App;


